import type { CSSProperties } from 'react'

import { cn } from '@/lib/utils'

import { HITCHHIKERS_PATH, HITCHHIKERS_VIEW_BOX } from './hitchhikersPath'

interface HitchhikersMarkProps {
  className?: string
  style?: CSSProperties
}

/** Marca Hitchhiker's Guide renderizada como SVG inline. */
export function HitchhikersMark({ className, style }: HitchhikersMarkProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={HITCHHIKERS_VIEW_BOX}
      preserveAspectRatio="xMidYMid meet"
      aria-hidden
      className={cn('block shrink-0', className)}
      style={style}
      fill="currentColor"
    >
      <path d={HITCHHIKERS_PATH} />
    </svg>
  )
}
